import React from 'react';
import styles from '../../styles/PeriodosStyles/PeriodosScreen.module.css';
import Pagination from '../../components/Pagination.tsx';
import { usePermissions } from '../../hooks/usePermissions';

const periodosMock = [
  { id: 1, nombre: 'Tetramestre', codigo: 'TETRA', numPorAno: 3, duracion: 12, estado: 'ACTIVO' },
  { id: 2, nombre: 'Semestre', codigo: 'SEM', numPorAno: 2, duracion: 15, estado: 'ACTIVO' },
  { id: 3, nombre: 'Trimestre', codigo: 'TRI', numPorAno: 4, duracion: 13, estado: 'INACTIVO' },
];

const StatusPill = ({ estado }) => (
  <span className={estado === 'ACTIVO' ? styles.statusActive : styles.statusInactive}>
    {estado}
  </span>
);

const ActionButtons = ({ periodo, onView, onEdit, onDelete, puedeEditar, puedeEliminar }) => (
  <div className={styles.actionButtons}>
    <button type="button" aria-label="Ver detalles" className={styles.actionButton} onClick={() => onView(periodo)}>
      <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/a1782ac5b190a9d29d8f798383eedda3f294d56b?placeholderIfAbsent=true" alt="Ver" className={styles.actionIcon} />
    </button>
    {puedeEditar && (
      <button type="button" aria-label="Editar" className={styles.actionButton} onClick={() => onEdit(periodo)}>
        <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/83eacec9f1f974b33615bbc95aea7ff7b2d13b0e?placeholderIfAbsent=true" alt="Editar" className={styles.actionIcon} />
      </button>
    )}
    {puedeEliminar && (
      <button type="button" aria-label="Eliminar" className={styles.actionButton} onClick={() => onDelete(periodo)}>
        <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/bef20ed4bd5293db48e37df8e511dca0fed7db2e?placeholderIfAbsent=true" alt="Eliminar" className={styles.actionIcon} />
      </button>
    )}
    {!puedeEditar && !puedeEliminar && (
      <span style={{ color: '#888', fontSize: '12px' }}>Solo lectura</span>
    )}
  </div>
);

const Header = () => (
  <div className={styles.tableHeader}>
    <div className={styles.tableTitle}>
      <div className={styles.tableTitleIcon}>
        <div className={styles.iconContainerOrange}><span>📅</span></div>
      </div>
      <h2 className={styles.tableTitleText}>Tipos de Periodos Académicos</h2>
    </div>
  </div>
);

export default function PeriodosTable({ periodos = periodosMock, loading = false, onView = () => {}, onEdit = () => {}, onDelete = () => {} }) {
  const [page, setPage] = React.useState(1);
  const pageSize = 8;
  const totalPages = Math.max(1, Math.ceil(periodos.length / pageSize));
  const paginated = periodos.slice((page - 1) * pageSize, page * pageSize);

  // PERMISOS
  const { canEdit, canDelete } = usePermissions();
  const puedeEditar = canEdit('Catálogos');
  const puedeEliminar = canDelete('Catálogos');

  if (loading) {
    return (
      <div className={styles.tableContainer}>
        <Header />
      </div>
    );
  }

  if (!periodos.length) {
    return (
      <div className={styles.tableContainer}>
        <Header />
        <div style={{ padding: '20px', textAlign: 'center' }}>No hay periodos registrados.</div>
      </div>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <Header />
      <div className={styles.tableHeaderRow}>
        <div className={styles.headerCell}>Periodo</div>
        <div className={styles.headerCell}>Código</div>
        <div className={styles.headerCell}>Número de periodos por año</div>
        <div className={styles.headerCell}>Duración (semanas)</div>
        <div className={styles.headerCell}>Estado</div>
        <div className={styles.headerCell}>Acciones</div>
      </div>
      <div className={styles.tableBody}>
        {paginated.map(periodo => (
          <div key={periodo.id} className={styles.tableRow}>
            <div className={styles.cellData}>{periodo.nombre}</div>
            <div className={styles.cellData}>{periodo.codigo}</div>
            <div className={styles.cellData}>{periodo.numPorAno}</div>
            <div className={styles.cellData}>{periodo.duracion}</div>
            <div className={styles.statusCell}><StatusPill estado={periodo.estado} /></div>
            <ActionButtons periodo={periodo} onView={onView} onEdit={onEdit} onDelete={onDelete} puedeEditar={puedeEditar} puedeEliminar={puedeEliminar} />
          </div>
        ))}
      </div>
      {/* Paginación global */}
      {totalPages > 1 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
          className={styles.pagination}
        />
      )}
    </div>
  );
}
